import { Router } from "@angular/router";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { MessageService } from "primeng/api";
import { Observable } from "rxjs/internal/Observable";
import { ResponseData } from "../helpers/response";
import {
  JSONisUnauthorized,
  getErrorMessage,
  isUnauthorized
} from "../helpers/function";
import { appInjector } from "../helpers/app-injector";
import { ConfigService } from "./config.service";
import { TokenService } from "../components/auth/token.service";
import { ClaimTypes } from "..//helpers/claimtype";

export class HttpBaseService {
  constructor(
    public configService?: ConfigService,
    public tokenService?: TokenService,
    public router?: Router,
    public http?: HttpClient,
    public toastr?: MessageService
  ) {
    if (!configService) {
      this.configService = appInjector().get(ConfigService);
    }

    if (!tokenService) {
      this.tokenService = appInjector().get(TokenService);
    }

    if (!router) {
      this.router = appInjector().get(Router);
    }

    if (!http) {
      this.http = appInjector().get(HttpClient);
    }

    if (!toastr) {
      this.toastr = appInjector().get(MessageService);
    }

    this.validateChangePassword();
  }

  validateChangePassword() {
    try {
      const model = JSON.parse(
        this.tokenService.getValueFromClaim(ClaimTypes.UserData)
      );

      if (model.ChangePassword) {
        this.router.navigate([
          this.configService.getAuthRoute().ChangePasswordUrl
        ]);
      }
    } catch (e) {}
  }

  postMethod(
    action: string,
    object: {},
    callback: Function,
    callbackError?: Function
  ) {
    this.setBlock();
    const observable = this.http.post<ResponseData>(
      `${this.configService.getUrlApi()}${action}`,
      object
    );

    this.subscribe(observable, callback, callbackError);
  }

  putMethod(
    action: string,
    object: {},
    callback: Function,
    callbackError?: Function
  ) {
    this.setBlock();
    const observable = this.http.put<ResponseData>(
      `${this.configService.getUrlApi()}${action}`,
      object
    );

    this.subscribe(observable, callback, callbackError);
  }

  patchMethod(
    action: string,
    object: {},
    callback: Function,
    callbackError?: Function
  ) {
    this.setBlock();
    const observable = this.http.patch<ResponseData>(
      `${this.configService.getUrlApi()}${action}`,
      object
    );

    this.subscribe(observable, callback, callbackError);
  }

  deleteMethod(action: string, callback: Function, callbackError?: Function) {
    this.setBlock();
    const observable = this.http.delete<ResponseData>(
      `${this.configService.getUrlApi()}${action}`
    );

    this.subscribe(observable, callback, callbackError);
  }

  getMethod(action: string, callback: Function, callbackError?: Function) {
    this.setBlock();
    const observable = this.http.get<ResponseData>(
      `${this.configService.getUrlApi()}${action}`
    );

    this.subscribe(observable, callback, callbackError);
  }

  subscribe(
    observable: Observable<ResponseData>,
    callback: Function,
    callbackError?: Function
  ) {
    const subscription = observable.subscribe(
      response => {
        this.setBlock(false);

        if (!response.Commit) {
          this.toastr.add({
            severity: "error",
            detail: response.Message
          });

          if (callbackError) {
            callbackError(response);
          }

          if (JSONisUnauthorized(response)) {
            if (this.tokenService) {
              this.tokenService.removeToken();
            }

            this.router.navigate([this.configService.getAuthRoute().LoginUrl]);
          }

          subscription.unsubscribe();
          return;
        }

        if (callback) {
          callback(response);
        }

        subscription.unsubscribe();
      },
      (error: HttpErrorResponse) => {
        this.toastr.add({
          severity: "error",
          detail: getErrorMessage(error)
        });

        if (callbackError) {
          callbackError(error);
        }

        if (isUnauthorized(error)) {
          this.router.navigate([this.configService.getAuthRoute().LoginUrl]);
        }

        this.setBlock(false);
        subscription.unsubscribe();
      }
    );
  }

  setBlock(value: boolean = true) {
    this.configService.emitter.emit({ BlockUI: value });
  }
}
